const loadPlanForEnv = () => {
  const env = process.env.REACT_APP_GOLDEN_PLAN_FILE;
  // For other environments.
  try {
    // This will attempt to load a file named ${env}
    // For example: plan_dev.json, plan_demo.json, etc.
    return require(`./${env}`);
  } catch (e) {
    console.warn(`Plan file for environment ${env} not found.`);
    return null;
  }
};

export const getSamplePlan = loadPlanForEnv(); 